import { h } from "snabbdom";
// import { Boot} from '@wangeditor/editor'
import {  DomEditor } from '@wangeditor/core'

// 渲染函数
function fn(elem, children, editor) {
  // elem 即当前节点
  // children 是下级节点
  // editor 即编辑器实例
  console.log(elem);
  let { a, b, c, d } = elem;
  a = a.split(",")[0];
  function anotherEventHandler() {
    // window.herf = d
  }
  const selected = DomEditor.isNodeSelected(editor, elem)
  const vnode = h(
    `div#container.two.classes.${selected?'selected':''}`,
    { on: { click: anotherEventHandler } },
    [
      h("div.OfficialAccounts", {}, [
        h("div.top", {}, [
          h("div.left", {}, [h("img", { src: a, alt: "" })]),
          h("div.center", {}, [
            h("div.center-top", {}, b),
            h("div.center-bottom", {}, c),
          ]),
          h("div.right", {}, [h("i.el-icon-arrow-right", {}, [])]),
        ]),
        h("div.bottom", {}, d),
      ]),
    ]
  );
  return vnode;
}

// 渲染配置
const conf = {
  type: "OfficialAccounts", // 节点 type ，重要！！！
  renderElem: fn,
};
export default conf;
